import societyApi from './api'
import societyHttp from './http'
import lodash from 'lodash'

let dictService = {
  mainDict: societyHttp.get(societyApi.libBaseSaas.dict),
  dict(key) {
    return new Promise((resolve, reject) => {
      dictService.mainDict.then(main => {
        const mainPromise = dictService.mainPromise = dictService.mainPromise || societyHttp.get(societyApi.libBaseSaas.dict, {params: {file: main.json}})
        mainPromise.then(mainContent => {
          if (dictService[key] = mainContent.content.find(item => item.name === key)) {
            dictService[key].promise = dictService[key].promise || societyHttp.get(societyApi.libBaseSaas.dict, {params: {file: dictService[key].url}})
            dictService[key].promise.then(resolve, reject)
          } else reject(key)
          dictService.mainDictContent = mainContent
        }, reject)
      }, reject)
    }).catch(reason => {
      console.log("Get Dict Error: reason=", reason)
    })
  },
  dist() {
    return dictService.dict('locCN').then(payload => {
      const arr = Object.keys(payload.content).map(dist2 => {
        return {
          value: dist2,
          label: payload.content[dist2].nameZh,
          children: [],
          loading: false
        }
      })
      arr.unshift({value: '00', label: '全国'})
      arr.getChildren = (node, callback) => {
        node.loading = true
        if (node.value.length === 2) {
          const dist4 = payload.content[node.value].dist4
          node.children = Object.keys(dist4).map(item => {
            return {
              value: item,
              label: dist4[item].nameZh,
              children: [],
              loading: false
            }
          })
          node.children.unshift({value: node.value + '00', label: '全部'})
          node.loading = false
          callback()
        } else if (node.value.length === 4) {
          const dist6 = payload.content[node.value.substr(0, 2)].dist4[node.value].dist6
          node.children = Object.keys(dist6).map(item => {
            return {
              value: item,
              label: dist6[item].nameZh,
            }
          })
          node.children.unshift({value: node.value + '00', label: '全部'})
          node.loading = false
          callback()
        }
      }
      return arr
    })
  },
  distCascaderGen(content) {
    let cascader = Object.keys(content["86"]).map(key => {
      return {
        value: key,
        label: content["86"][key],
        children: [],
        loading: false
      }
    })

    // noinspection JSCheckFunctionSignatures
    cascader.unshift({value: '000000', label: '全国'})

    cascader.getChildren = (node, callback) => {
      node.loading = true
      node.children = Object.keys(content[node.value]).map(key => {
        if (node.value.substr(2, 4) === '0000') {
          return {
            value: key,
            label: content[node.value][key],
            children: [],
            loading: false,
          }
        } else {
          return {
            value: key,
            label: content[node.value][key],
          }
        }
      })
      node.children.unshift({value: node.value, label: '全' + node.label.substr(node.label.length - 1, 1)})
      node.loading = false
      callback()
    }

    return cascader
  },
  // 根据词典中的地区信息生成级联菜单的数据
  distCascader(dictName) {
    console.log("dictService, distCascader", dictName)
    if (dictName)
      return dictService.dict(dictName).then(payload => {
        return dictService.distCascaderGen(payload.content)
      })
    else
      return dictService.dict('dist').then(distPayload => {
        return dictService.dict('dist.update').then(payload => {
          return dictService.distCascaderGen(lodash.merge(distPayload.content, payload.content))
        })
      })
  },
  // 计算三级数据供Cascader使用
  distCascaderValue(dist6) {
    return dist6 ? [dist6.substr(0, 2) + '0000', dist6.substr(0, 4) + '00', dist6] : []
  },
  dist6nameZh(val) {
    return dictService.dict('locCN').then(payload => {
      let nameZh = '',
        dict2, dict4, dict6
      if (dict2 = payload.content[val.substr(0, 2)]) {
        nameZh = dict2.nameZh + ' '
        if (dict4 = dict2.dist4[val.substr(0, 4)]) {
          nameZh += dict4.nameZh + ' '
          if (dict6 = dict4.dist6[val]) {
            nameZh += dict6.nameZh
          }
        }
      }
      return nameZh || '--'
    })
  }
  ,
  dist6(val) {
    return val ? [val.substr(0, 2), val.substr(0, 4), val] : []
  }
  ,
  getDist6(val) {
    return val ? (val + '000000').substr(0, 6) : ''
  }
  ,
  getDist6Res(val) {
    return val && val instanceof Array && val.length > 0 ? (val[val.length - 1] + '000000').substr(0, 6) : ''
  }
  ,
  save(node) {
    const dictContent = {}
    node.form.map(item => dictContent[item.key] = item.value)
    return societyHttp.post(societyApi.libBaseSaas.dict, {file: node.url, dictContent: dictContent})
  }
  ,

  // 获取Vant格式的地区数据
  getDistVant(dictName) {
    return  dictService.dict('dist.support').then(payload => {
      let distList = {province_list: {}, city_list: {}, county_list: {}}

      lodash.forIn(payload.content["86"], (value, key) => {
        distList.province_list[key] = value
      })

      lodash.forIn(distList.province_list, (value, key) => {
        lodash.forIn(payload.content[key], (v, k) => {
          distList.city_list[k] = v
        })
      })

      lodash.forIn(distList.city_list, (value, key) => {
        lodash.forIn(payload.content[key], (v, k) => {
          distList.county_list[k] = v
        })
      })

      return distList
    })
  },

// VUX生成级联菜单 sys.dist.support: 查询单独的省市区 ;;; locCN: 查询所有的省市区
      distSpecial(dictName)
    {
      return dictService.dict(dictName).then(payload => {
        console.debug("distSpecial: dictName, payload", dictName, payload)
        let resultList = []
        Object.keys(payload.content).map(dist2 => {
          const dist22 = payload.content[dist2]
          resultList.push({value: dist2, name: dist22.nameZh, parent: 0})
          if (Object.keys(dist22.dist4).length !== 0) {
            if (societyApi.baseUrl.split('/sealsite/')[1].substr(2, 2) === '00') {
              resultList.push({value: dist2 + '00', name: '全省', parent: dist2})
              resultList.push({value: dist2 + '0000', name: '', parent: dist2 + '00'})
            }
            Object.keys(dist22.dist4).map(dist4 => {
              const dist44 = payload.content[dist2].dist4[dist4]
              if (dist44.nameZh) {
                resultList.push({value: dist4, name: dist44.nameZh, parent: dist2})
                if (Object.keys(dist44.dist6).length !== 0) {
                  resultList.push({value: dist4 + '00', name: '全部', parent: dist4})
                  Object.keys(dist44.dist6).map(dist6 => {
                    const dist66 = payload.content[dist2].dist4[dist4].dist6[dist6]
                    if (societyApi.baseUrl.split('/sealsite/')[1].substr(2, 2) !== '00') resultList.push({
                      value: dist6,
                      name: dist66.nameZh,
                      parent: dist4
                    })
                  })
                }
              } else {
                resultList.push({value: '', name: '', parent: dist4})
              }
            })
          } else {
            resultList.push({value: '11', name: '', parent: dist2})
            resultList.push({value: '22', name: '', parent: '11'})
          }
        })
        console.log(resultList)
        return resultList
      })
    }
  ,
  }

  export default dictService
